// src/hooks/useOrderEditing.js
import { useCallback } from 'react';
import config from '../config';

const host = config.backendUrl;

export default function useOrderEditing({ order, setOrder, orderId, authToken }) {
  const updateChoices = useCallback((path, value) => {
    fetch(`${host}/api/admin/update-value/${orderId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ path, value }),
    })
      .then((res) => res.json())
      .catch((err) => console.error('Failed to update value:', err));
  }, [orderId, authToken]);

  const updateNestedValue = useCallback((obj, path, value) => {
    const keys = path.split('.');
    const lastKey = keys.pop();

    let current = obj;
    for (const key of keys) {
      if (key.includes('[')) {
        const arrayName = key.substring(0, key.indexOf('['));
        const index = parseInt(key.substring(key.indexOf('[') + 1, key.indexOf(']')));
        current[arrayName] = current[arrayName] || [];
        current[arrayName][index] = current[arrayName][index] || {};
        current = current[arrayName][index];
      } else {
        current[key] = current[key] || {};
        current = current[key];
      }
    }

    if (lastKey.includes('[')) {
      const arrayName = lastKey.substring(0, lastKey.indexOf('['));
      const index = parseInt(lastKey.substring(lastKey.indexOf('[') + 1, lastKey.indexOf(']')));
      current[arrayName] = current[arrayName] || [];
      current[arrayName][index] = value;
    } else {
      current[lastKey] = value;
    }

    return obj;
  }, []);

  const handleEditValue = useCallback((itemIndex, path, currentValue) => {
    const newValue = prompt('Enter new value:', currentValue);
    if (newValue === null) return;

    const newOrder = JSON.parse(JSON.stringify(order));
    const choicePath = `items[${itemIndex}].choices.${path}`;

    newOrder.items[itemIndex].choices = updateNestedValue(
      newOrder.items[itemIndex].choices,
      path,
      newValue
    );

    setOrder(newOrder);
    console.log(choicePath);
    updateChoices(choicePath, newValue);
  }, [order, setOrder, updateChoices, updateNestedValue]);

  const handleEditShippingValue = useCallback((path, currentValue) => {
    const newValue = prompt('Enter new value:', currentValue);
    if (newValue === null) return;

    const newOrder = JSON.parse(JSON.stringify(order));
    const parts = path.split('.');
    let current = newOrder;
    for (let i = 0; i < parts.length - 1; i++) {
      current = current[parts[i]];
    }
    current[parts[parts.length - 1]] = newValue;

    setOrder(newOrder);
    updateChoices(path, newValue);
  }, [order, setOrder, updateChoices]);

  const handleEditQuantity = useCallback((itemIndex, currentValue) => {
    const input = prompt('Enter new quantity:', currentValue);
    if (input === null) return;

    const newValue = Number.parseInt(input, 10);
    if (!Number.isInteger(newValue) || newValue < 1) return;

    const newOrder = JSON.parse(JSON.stringify(order));
    newOrder.items[itemIndex].quantity = newValue;

    setOrder(newOrder);
    updateChoices(`items[${itemIndex}].quantity`, newValue);
  }, [order, setOrder, updateChoices]);

  return {
    handleEditValue,
    handleEditShippingValue,
    updateNestedValue,
    updateChoices,
    handleEditQuantity
  };
}
